import { render, staticRenderFns } from "./CreateCompany.yaml?vue&type=template&id=18b92d1b&component"
import script from "./CreateCompany.yaml?vue&type=script&lang=ts&component"
export * from "./CreateCompany.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports